<script>
import Layout from '@layouts/main'
import {AxiosHelper} from '@src/utils/utils';
import Datatable from '@components/Datatable';
import moment from 'moment';


export default {
	components: { Layout, Datatable },
  data() {
    return {
			title: '공유링크 관리',

			modal : {
				title : '',
				modalText : '',
			},
			
			tableData : [],

			tableOption : {
				scrollY: 440,
				columns : [
					{data : 'share_id'},
					{data : 'share_name'},
					{data : 'share_list'},
					{data : 'expire_time'},
				],
				columnDefs : [
					{
						render : function(data, type, row) {
							return `<a href="javascript:;">${data}</a>`;
						},
						targets : 0
					},
					{
						render : function(data, type, row) {
							const datas = JSON.parse(data);
							return `<a href="javascript:;">${datas.length}건</a>`;
						},
						targets : 2
					},
					{
						render : function(data, type, row) {
							if(data < new Date().getTime()) {
								return `만료`;
							}
							return moment(data).format('YYYY.MM.DD HH:mm:ss');
						},
						targets : 3
					},
					{
						render : function(data, type, row) {
							var timeExtend = '<button type="button" data-type="extend" class="btn btn-blue btn-xs waves-effect waves-light">연장</button>';
							var removeItem = '<button type="button" data-type="remove" class="btn btn-danger btn-xs waves-effect waves-light">삭제</button>';
							return `<div class="button-list">
												${timeExtend}
												${removeItem}
											</div>`;
						},
						targets : 4
					},
				]
			},

    }
	},
	mounted() {
		this.reload();
	},
	methods : {
		reload : function() {
			AxiosHelper.get('/api/music/share').then(ret => {
				this.tableData = ret.data;
			});
		},

		tableClick : function(index, data, event) {
			event.preventDefault();
			event.stopPropagation();

			if(index.column === 0) {
				window.open(`${window.location.origin}/music/share/${data.share_id}`);
			}
			else if(index.column === 2) {
				let list = [];
				const datas = JSON.parse(data.share_list);
				for(var i = 0; i < datas.length; i++) {
					list.push(<p key={data.share_id + i}>{datas[i].artist} - {datas[i].title}</p>);
				}

				this.modal.title = data.share_name;
				this.modal.modalText = list;
				this.$refs.shareItemsModal.show();
			}
			else if(index.column === 4) {
				
				if(event.target.dataset.type === 'extend') {
					AxiosHelper.patch(`/api/music/share/${data.share_id}/extend`).then(ret => {
						this.reload();
					});
				}
				else if(event.target.dataset.type === 'remove') {
					AxiosHelper.delete(`/api/music/share/${data.share_id}`).then(ret => {
						this.reload();
					});
				}
			}
		},
		
	}
}
</script>

<template>
  <Layout>
    <C.PageHeader :title="title" />

		<C.Row>
			<C.Col lg="12">
				<C.Card>
					<C.CardBody>
						<Datatable :option="tableOption"
							:data="tableData"
							@clickHandler="tableClick"
						>
							<template v-slot:thead>
								<tr>
									<th>링크 주소</th>
									<th>링크 설명</th>
									<th>목록</th>
									<th>만료시간</th>
									<th>액션</th>
								</tr>
							</template>
						</Datatable>
					</C.CardBody>
				</C.Card>
			</C.Col>
		</C.Row>
		<C.Modal ref="shareItemsModal" :title="modal.title"
			dialog-class-name='modal-dialog-scrollable'
		>
			{{modal.modalText}}
		</C.Modal>
  </Layout>
</template>